import { create } from "zustand";

export type OverCapacityLimitType = "TIME_RANGE" | "DAY" | "CONCURRENT";

export interface OverCapacityLimit {
  type: OverCapacityLimitType;
  limit: number;
  confirmedCount: number;
  rangeStart: string;
  rangeEnd: string;
}

interface OverCapacityState {
  limits: OverCapacityLimit[] | null;
  resolveAnswer: ((accepted: boolean) => void) | null;
  ask: (limits: OverCapacityLimit[]) => Promise<boolean>;
  answer: (accepted: boolean) => void;
}

export const useOverCapacityStore = create<OverCapacityState>((set, get) => ({
  limits: null,
  resolveAnswer: null,
  ask: (limits) => {
    get().resolveAnswer?.(false);
    return new Promise<boolean>((resolve) => {
      set({ limits, resolveAnswer: resolve });
    });
  },
  answer: (accepted) => {
    get().resolveAnswer?.(accepted);
    set({ limits: null, resolveAnswer: null });
  },
}));
